import React from 'react';
import { Spinner } from '@chakra-ui/react';
import { RenderIf } from '../RenderIf/RenderIf';
import useCanUserViewFeature from '../../../hooks/useCanUserViewFeature';
export const PermissionGuard = (props) => {
    const { canView, isLoading } = useCanUserViewFeature(props.permissions, props.resource, props.strategy);
    if (!canView || props.overrideCondition)
        return null;
    if (isLoading && props.showLoadingSpinner)
        return React.createElement(Spinner, null);
    return React.createElement(RenderIf, { condition: canView }, props.children);
};
